import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["cancelBtn"];

  cancel() {
    const frame = this.element.closest("turbo-frame");
    const original = this.cancelBtnTarget.dataset.original;
    if (frame && original !== undefined) {
      frame.innerHTML = original;
    }
  }
}
